import { TemplatePage } from './types';

const live_streaming_linkedin_remastered_theme: TemplatePage = {
  header: {
    color: '#98C4DF',
    icon: 'images/video-templates/linkedin_remastered_theme.jpg',
    title: 'Live Stream Templates — LinkedIn Remastered Theme',
    title_meta: '10+ Free Live Stream Templates — LinkedIn Remastered Theme',
    description_meta:
      'Make a memorable design for your online event with Wave.video’s LinkedIn-Remastered-themed' +
      ' templates. The set contains transition screens, overlays, and frames.',
    description:
      'Make a unique design for your online conference following the example of Wave.video’s' +
      ' LinkedIn-Remastered-themed templates. Create thumbnails, intros, transition screens, lower thirds,' +
      ' and more to impress your attendees.'
  },
  footer: {
    category: 'Live streaming spiritual theme',
    description:
      'With Wave.video’s themed collections of editable templates, you don’t need a design team to create' +
      ' a unique look for your online conference. Every set contains everything you need to promote and' +
      ' conduct a 5-star event: promo videos, intros, outros, technical screens, lower thirds, and many' +
      ' more! All you need to do is change the color palette, titles, dates, and names - and you’re all' +
      ' set!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming LinkedIn remastered theme',
      search: {
        name: 'LinkedInRemasteredTheme',
        tags: 'LinkedInRemasteredTheme'
      }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_linkedin_remastered_theme;
